export default "__VITE_ASSET__DOx93x_7__"